import {Box, Typography} from '@mui/material';
import React from 'react';

export type PageHeaderProps = {
  /** The page's one h1. */
  title: string;
  /** A line under the title: plain text, or a status line built of spans. */
  subtitle?: React.ReactNode;
  /** Buttons beside the title (wrap under it on phones). */
  actions?: React.ReactNode;
  /** Rendered above the title, e.g. <AppBreadcrumbs />. */
  breadcrumbs?: React.ReactNode;
};

export const PageHeader = ({
  title,
  subtitle,
  actions,
  breadcrumbs,
}: PageHeaderProps) => (
  <Box component="header" data-testid="page-header" sx={{mb: 3}}>
    {breadcrumbs}
    <Box
      sx={{
        display: 'flex',
        flexDirection: {xs: 'column', sm: 'row'},
        justifyContent: 'space-between',
        alignItems: {xs: 'flex-start', sm: 'center'},
        gap: 2,
      }}>
      <Box sx={{minWidth: 0}}>
        <Typography variant="h1" sx={{color: 'text.primary'}}>
          {title}
        </Typography>
        {subtitle && (
          <Typography
            data-testid="page-header-subtitle"
            variant="body1"
            sx={{color: 'text.secondary', mt: 0.5}}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{display: 'flex', gap: 1, flexShrink: 0}}>{actions}</Box>
      )}
    </Box>
  </Box>
);
